import { lazy, Suspense } from "react";

const ButtonMUI = lazy(() => import('@mui/material/Button'));
//import ButtonMUI from '@mui/material/Button';

import {getButtonStyle, getIconButtonStyle} from '@/utils/Styles';

const IconButton = lazy(() => import('@mui/material/IconButton'));

export default function Button({ref,id,text,icon,onClick,type,variant,disabled,sx,startIcon,endIcon,color,className}){

	var classString = '';
	if(className){
		classString = className;
	}

	let sxButton;
	if(icon){
		sxButton = getIconButtonStyle();
	}
	else{
		sxButton = getButtonStyle();
	}

	if(sx){
		sxButton = {...sxButton,...sx};
	}

	var colorString = '';

	// outlined, contained
	var variantType = 'outlined';	

	if(type){
		
		switch(type){

			case 'login':
				sxButton.backgroundColor = "#FFFFFF";
				//colorString="error";
				if(!color){
					sxButton.color = "#810000"; // text				
				}
				//sxButton.border = '1px solid white';
				//sxButton.boxShadow = '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)';
				sxButton['&:hover'] = {backgroundColor: '#cccccc'};
				break;

			case 'accept':
				colorString = 'error';
				variantType = 'contained';
				break;

			case 'reset':	
			case 'delete':					
				colorString = "error";
				break;

			case 'no':		
				colorString = "error";
				variantType = "contained";
				break;

			case 'save':
			case 'yes':
				colorString = "success";
				variantType = "contained";
				break;

			case 'edit':
				colorString = "secondary";				
				break;

			case 'up':
				colorString = "secondary";				
				break;

			case 'add':
			case 'send':
			case 'download':
				colorString = "primary";
				break;

			case 'filter':
				colorString = "warning";
				break;

			case 'close':
				colorString = "error";
				variantType = "contained";
				break;

			case 'open':
				colorString = "success";
				variantType = "contained";
				break;

			case 'back':
				sxButton.backgroundColor="#000000"; // background

				if(!color){
					sxButton.color = "#FFFFFF"; // text	
				}
				variantType = "contained";

				sxButton['&:hover'] = {					
					backgroundColor: '#333333', 					
					//color: '#FFFFFF', 					
					//boxShadow: 'none'
				};
				break;

			case 'select':
				colorString = "error";
				break;

			case 'config':				
				//colorString = "";
				break;

			case 'share':
				colorString = "success";
				break;

			case 'root':
				colorString = "error";				
				break;

			case 'refresh':
				colorString = "warning";				
				break;

			case 'app':
				// with app red colour
				//colorString = "error";
				variantType='contained';
				sxButton.backgroundColor = "rgb(129,0,0,1)"; // background		

				if(!color){
					sxButton.color = "#FFFFFF"; // text
				}
				break;

			case 'appoutlined':
				// with app red colour			
				variantType='outlined';				

				if(!color){
					sxButton.color = "rgb(129,0,0,1)"; // text
				}

				sxButton['&:hover'] = {
			     	color: "#FFFFFF", 
			    	backgroundColor: "rgb(129,0,0)",
			    	borderColor: "rgb(129,0,0)"
			    };
				break;

			case 'export':				
				variantType='outlined';				

				if(!color){
					sxButton.color = "#000000";
				}
				break;

			case 'richtext':
				//variantType='outlined';
				if(!color){
					sxButton.color = "#000000"; // text
				}
				//sxButton.textDecorationThickness = "1px";				
				sxButton.paddingX = 1;	
				sxButton.paddingY = 0.2;	
				break;
		}
	}

	if(color){
		colorString = color;
	}

	if(variant){
		variantType = variant;
	}

	return (
		icon ? 
			<IconButton
				ref={ref}
				id={id}
				sx={sxButton}
                onClick={onClick}
                color={colorString}
                disabled={disabled}
            >
                {icon}
            </IconButton>
		:
			<ButtonMUI
				ref={ref}
				type="button" 
				id={id}
	            variant={variantType}
	            color={colorString}
	            onClick={onClick}
	            sx={sxButton}
	            className={classString}
	            disabled={disabled}
	            startIcon={startIcon}
	            endIcon={endIcon}            
	        >
	            {text}
	        </ButtonMUI>
	);
}